import CommentSugggest from "./CommentSuggest";

export default function RateOption({ handleComment, handleRating, handleSendRating, rate, data, isSubmit, comment, disabled }) {
  return (
    <div className={`${data.rate > 0 ? "hide" : ""} container rate-container ${!isSubmit ? "" : "hide"} `}>
      <div className="row">
        <div className="offset-md-1 col-md-10">
          <div className="header-rating"> กรุณาให้คะแนนการให้บริการของล่ามภาษามือเพื่อนำมาปรับปรุงการให้บริการ </div>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="offset-md-1 col-md-10">
          <div className="field-rating">
            <div className="div-icon-rating">
              <div onClick={() => handleRating(5)} className={`${rate > 0 && rate !== 5 ? "noselect span-rate" : "span-rate"}`}>
                <span className="icon-rating">
                  <img className="point-img" src="../images/rate-5.png" alt="good" />{" "}
                </span>
                <span className="text-rating"> มากที่สุด </span>
              </div>
              <div onClick={() => handleRating(4)} className={`${rate > 0 && rate !== 4 ? "noselect span-rate" : "span-rate"}`}>
                <span className="icon-rating">
                  <img className="point-img" src="../images/rate-4.png" alt="medium" />{" "}
                </span>
                <span className="text-rating"> มาก </span>
              </div>
              <div onClick={() => handleRating(3)} className={`${rate > 0 && rate !== 3 ? "noselect span-rate" : "span-rate"}`}>
                <span className="icon-rating">
                  <img className="point-img" src="../images/rate-3.png" alt="good" />{" "}
                </span>
                <span className="text-rating"> ปานกลาง </span>
              </div>
              <div onClick={() => handleRating(2)} className={`${rate > 0 && rate !== 2 ? "noselect span-rate" : "span-rate"}`}>
                <span className="icon-rating">
                  <img className="point-img" src="../images/rate-2.png" alt="medium" />{" "}
                </span>
                <span className="text-rating"> น้อย </span>
              </div>
              <div onClick={() => handleRating(1)} className={`${rate > 0 && rate !== 1 ? "noselect span-rate" : "span-rate"}`}>
                <span className="icon-rating">
                  <img className="point-img" src="../images/rate-1.png" alt="bad" />
                </span>
                <span className="text-rating"> น้อยที่สุด </span>
              </div>
            </div>
            <CommentSugggest />
            <div className={`${rate !== 0 ? "" : "hide"}`}>
              <div className="label-rating" style={{ textAlign: "left" }}>
                โปรดแสดงความคิดเห็นเพิ่มเติม
              </div>
              <textarea
                disabled={disabled}
                id="comment"
                maxLength="1000"
                className="input-rating"
                rows="10"
                onChange={handleComment}
                value={comment}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="offset-md-1 col-md-10 submit-survey">
          <div className={`${rate > 0 ? "" : "hide"} `}>
            <br />
            <button type="button" className="btn btn-success btn-block" onClick={handleSendRating} disabled={disabled}>
              ส่งการประเมินความพึงพอใจ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
